import { useTranslation } from 'react-i18next';

import { cn } from '@/styles/tailwind-utils';
import { AddIcon } from '@lib/icons';

export function AddCustomCard({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'relative flex flex-col items-center gap-3 rounded-md border-2 border-dashed p-4 text-center transition-all duration-150',
        'border-border bg-surface text-muted-foreground',
        'hover:border-brand-light hover:text-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2',
      )}
    >
      <span className="text-muted-foreground">
        <AddIcon />
      </span>
      <span className="text-xs font-medium leading-tight">{t('specialties.addCustomButton')}</span>
    </button>
  );
}
